import { FC, useState } from "react";
import { toast } from "react-toastify";
import { requestsRepository } from "../../../api/RequestsRepository";
import { CustomButton } from "../../CustomButton/CustomButton";
import { CloseIconModal, ModalComponent } from "../UiModals";

interface IProps {
    onSuccess: () => void;
    userName: string;
    userId: string;
    chatId: string;
}

interface IPropsActions extends IProps {
    close: () => void;
}

const Modal: FC<IPropsActions> = ({
                                      close,
                                      onSuccess,
                                      userName,
                                      userId,
                                      chatId
                                  }) => {
    const [loader, setLoader] = useState(false);
    const deleteChat = () => {
        setLoader(true);
        requestsRepository.ChatApiService.changeVisible(userId, chatId, false).then(res => {
            if (res.success) {
                onSuccess();
            } else {
                toast.error(res.message);
            }
        }).finally(() => setLoader(false));
    }

    return (
        <div className="communication-modal-content" style={{ width: 400 }}>
            <div className="communication-modal-title" style={{padding: 20}}>
                <div style={{fontWeight: 600, fontSize: 18}}>Удалить чат</div>
                <div className="communication-modal-title__close" onClick={close}><CloseIconModal /></div>
            </div>
            <div className="communication-modal-body" style={{padding: '0 20px 20px 20px'}}>
                <div className="communication-modal-content" style={{fontSize: 14, marginBottom: 24}}>
                    Вы действительно хотите удалить чат с пользователем <b>{userName}</b>?
                </div>
                <div className="communication-modal-footer">
                    <CustomButton
                        style={{maxHeight: 40, padding: '8px 12px'}}
                        outline
                        onClick={close}
                    >
                        Отменить
                    </CustomButton>
                    <CustomButton
                        style={{maxHeight: 40, padding: '8px 12px'}}
                        onClick={deleteChat}
                        loading={loader}
                        isCancel={true}
                    >
                        Удалить
                    </CustomButton>
                </div>
            </div>
        </div>
    );
};

export const DeleteChat = (props: IProps): ModalComponent => {
    return ({ close }) => {
        return <Modal close={close} {...props} />;
    };
};
